import React, { useState, useEffect, useMemo } from "react";
import { FalconLogo, FalkonDocSignerDoneIcon } from "../../icon";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";

interface Props { }

const DisplaySignerSuccessMaessageComponent: React.FC<Props> = (props) => {
    const location = useLocation();
    const state = location.state as {
        filename?: string;
        isComplete?: boolean;
        isNotActive?: boolean;
    } | null;
    const fileName = state?.filename ?? "this document";
    const isComplete = state?.isComplete ?? false;
    const isNotActive = state?.isNotActive ?? false;
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    const getTitle = () => {
        if (isNotActive) {
            return "Document Not Available";
        }
        return isComplete ? "You've already finished" : "You've finished";
    };

    const getMessage = () => {
        if (isNotActive) {
            return "This document has been deleted by the owner.";
        }
        return "Once the completed agreement has been signed by all parties, we will forward it to you.";
    };

    return (
        <div>
            <div className={"d-flex pt-5 w-p-100 align-center"}>
                <div className="mx-auto">
                    <FalconLogo className="" />
                </div>
            </div>
            <div className={`success-main-content d-flex align-center t-align-center mx-auto`}>
                <div className="w-p-100 h-p-60 d-flex justify-center align-center">
                    <div className="t-align-center">
                        <div className="check-icon d-inline-flex justify-center align-center mx-auto">
                            <FalkonDocSignerDoneIcon />
                        </div>
                        <h2 className="h2-medium color-primary-accent-alt mb-2 px-2">
                            {getTitle()}{!isNotActive && ` signing ${fileName}`}
                        </h2>
                        <p className="h2-medium color-primary-accent-alt px-2">
                            {getMessage()}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisplaySignerSuccessMaessageComponent;
